import React, { useCallback } from 'react'

import type { SettingsOptions } from '.'
import { Action } from './types'

import { checkDotNet } from './utilities'

import { useSendMessage } from './useSendMessage'

export const useManageSettings = () => {

  const { host, sendMessage } = useSendMessage()

  const sendSettings = useCallback((uniqueId: string, settings: SettingsOptions) => {

    return sendMessage('AddSettings' as Action, { uniqueId, data: settings })
    
  }, [sendMessage])

  const getSettings = useCallback((key: string = performance.now().toString()) => {
    if (!checkDotNet()) return
    
    let settings

    try {
      settings = window.parent.chrome.webview.hostObjects.sync.settings.Get(key).data
    } catch {
      try {
        settings = window.parent.chrome.webview.hostObjects.sync.settings.GetModelSettings()
      } catch {
        throw new Error('Neither window.parent.chrome.webview.hostObjects.sync.settings.GetModelSettings() nor .Get() are available on this platform.')
      }
    }

    return settings
  }, [])

  return ({
    host,
    sendSettings,
    getSettings,
  })
}
